import { Location } from '@cobliteam/common-types';
import { useUser } from '@cobliteam/hooks';
import { Redirect, Route, Switch } from 'react-router-dom';

const CoachingPage = ({ routes }: any) => {
  const { data: userData } = useUser().useGetUserData();
  const hasCameraFlag = userData?.hasCameraFlag;
  return (
    <Switch>
      {!hasCameraFlag && <Redirect path='*' to={Location.NOT_FOUND} />}
      {routes.map((route: any) => {
        return <Route key={route.path} path={route.path} exact={route.exact} render={(props) => <route.component {...props} routes={route.routes} />} />;
      })}
    </Switch>
  );
};

export default CoachingPage;
